import React, { useEffect, useRef, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
// import HardwareEditAddOmAssigned from "./HardwareEditAddOmAssigned";
import { replaceHardwareProjectTrack, replaceWorkEntriesProjectTrack, saveUpdateDescriptionTask } from "../../../../../store/slices/managerEditTrackingEntries";
import { setProjectReadTrue } from "../../../../../store/slices/readSlice";
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import { deleteTask, fetchWorkEntriesProjectTracking } from "../../../../../store/slices/workentriesSlice";
import { deleteDescriptionTask, fetchDescriptionTasksProjectTracking } from "../../../../../store/slices/DescriptionTask";
import { deleteHardwareDescription, fetchHardwareDescriptions, fetchHardwareProjectTracking } from "../../../../../store/slices/hardwareDescriptionSlice";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";
import {
    formatAmountComma,
    formatAmountForInput,
    validateAmountValue,
    parseAmountNumber,
} from "../../../../../utils/decimalAmountUtils";
import { getAllAssemblyInventory } from "../../../../../store/slices/assemblyInventorySlice";
import { fetchGroups } from "../../../../../store/slices/groupSlice";
import { isTrainingExpenseEntry } from "../../../../../utils/trainingOtherExpenseSync";
const ShowAssignTableManager = ({
    refreshAssign,
    row,
    emp,
    setIsLoading,
    employees,
    matchedOldRowDesctiption,
    matchedOldRowEntries,
    showListState,
    clickedPersonId,
    setClickedPersonId,
    isViewOnly = false
}) => {
    const sanitizeDecimalInput = (inputValue) => {
        const cleaned = String(inputValue ?? "").replace(/[^0-9.]/g, "");
        const [integerPart, ...decimalParts] = cleaned.split(".");
        if (decimalParts.length === 0) return integerPart;
        return `${integerPart}.${decimalParts.join("")}`;
    };
    const roundHours = (value) => Number((Math.round((value + Number.EPSILON) * 100) / 100).toFixed(2));
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const currency = useCurrencySymbol();
    const USAComma = CommaConvert();
    const { inventory } = useSelector((state) => state.assemblyInventory);
    const { group: groups } = useSelector((state) => state.group);
    const isSyntheticTrainingExpenseRow = (entry) =>
        Boolean(entry?.readOnly || entry?._prmSyntheticTrainingExpense) &&
        (
            isTrainingExpenseEntry(entry) ||
            String(entry?.description || "").trim().toLowerCase().startsWith("training cost")
        );

    useEffect(() => {
        dispatch(fetchHardwareDescriptions());
        dispatch(getAllAssemblyInventory());
        dispatch(fetchGroups());
    }, [dispatch]);

    const groupNameById = React.useMemo(() => {
        const map = new Map();
        (groups || []).forEach((g) => {
            const id = g?._id || g?.id;
            const name = g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
            if (id && name) map.set(String(id), name);
        });
        return map;
    }, [groups]);

    const selectedGroupName = React.useMemo(() => {
        const groupId = row?.groupid?._id || row?.groupid;
        if (groupId && groupNameById.has(String(groupId))) {
            return groupNameById.get(String(groupId));
        }
        return row?.AssignedGroup || "";
    }, [row, groupNameById]);

    const selectedProjectId = row._id;
    const [projectTasksEntriesAssiged, setProjectTasksEntriesAssigned] = useState(
        []
    );
    const [projectDescriptionsAssiged, setProjectDescriptionsAssiged] = useState(
        []
    );
    const [loggedEmp, setLoggedEmp] = useState({});
    const [tripDurationInput, setTripDuration] = useState();

    const handleTripDuration = (e) => {
        if (isViewOnly) return;
        const value = e.target.value;
        setTripDuration(value)
    }

    const [, setShowAction] = useState({ empId: null, type: "" });
    useEffect(() => {
        setShowAction({ empId: null, type: null });
    }, [emp?._id]);
    useEffect(() => {
        const Email = localStorage.getItem("email");
        const LoggedEmp = employees.find((emp) => emp.EmpEmail === Email);
        setLoggedEmp(LoggedEmp);
    }, [employees]);

    const [hardwarePartsOp, setHardwarePartsOp] = useState([])
    const tripDuration = tripDurationInput ?? projectDescriptionsAssiged?.[0]?.tripduration ?? "";

    const isInitialized = useRef(false);

    useEffect(() => {
        if (isInitialized.current) return;
        if (emp?.HardwareParts?.length > 0) {
            setHardwarePartsOp(emp.HardwareParts);
        } else {
            setHardwarePartsOp([{
                assemblepartdescription: "",
                partno: "",
                quantity: "",
                unitprice: "",
                totalprice: "",
            }]);
        }
        isInitialized.current = true;
    }, [emp]);

    const isWorkEntriesInit = useRef(false);
    const isDescriptionInit = useRef(false);

    useEffect(() => {
        if (!isWorkEntriesInit.current && emp?.workEntries?.length > 0) {
            setProjectTasksEntriesAssigned(emp.workEntries);
            isWorkEntriesInit.current = true;
        }
        if (!isDescriptionInit.current) {
            if (emp?.DescriptionList?.length > 0) {
                setProjectDescriptionsAssiged(emp.DescriptionList);
            } else {
                setProjectDescriptionsAssiged([]);
            }
            isDescriptionInit.current = true;
        }
    }, [emp]);

    useEffect(() => {
        const incomingTrainingRows = (emp?.DescriptionList || []).filter(isSyntheticTrainingExpenseRow);
        if (!incomingTrainingRows.length) return;

        setProjectDescriptionsAssiged((prev) => {
            const manualRows = (prev || []).filter((entry) => !isSyntheticTrainingExpenseRow(entry));
            return [...manualRows, ...incomingTrainingRows];
        });
    }, [emp?.DescriptionList]);

    const handleInputChange = (index, field, value) => {
        if (isViewOnly) return;
        setProjectTasksEntriesAssigned((prevRows) => {
            const newRows = [...prevRows];

            let validatedValue = value;
            if (field === "hoursassigned") {
                validatedValue = sanitizeDecimalInput(value);
            } else if (field === "task" || field === "notes") {
                validatedValue = value.replace(/[^a-zA-Z0-9 .,?'-]/g, "");
            }

            newRows[index] = {
                ...newRows[index],
                [field]: validatedValue,
            };

            return newRows;
        });
    };

    const handleAddTaskRow = () => {
        if (isViewOnly) return;
        if (projectTasksEntriesAssiged?.length === 0) {
            // If state is empty, add default row
            const newRow = { task: "", hoursassigned: "", notes: "" };
            setProjectTasksEntriesAssigned([newRow]);
        } else if (projectTasksEntriesAssiged.length < 15) {
            // Otherwise, add a new row normally
            setProjectTasksEntriesAssigned([
                ...projectTasksEntriesAssiged,
                { task: "", hoursassigned: "", notes: "" },
            ]);
        } else {
            // Optional: show a snackbar or message
            // enqueueSnackbar("You can only add up to 15 rows.", { variant: "error" });
        }
    };

    const handleRemoveTaskRow = (index) => {
        if (isViewOnly) return;
        setProjectTasksEntriesAssigned((prev) => {
            const rowToRemove = prev[index];
            if (
                prev.length === 1 &&
                rowToRemove.task === "" &&
                rowToRemove.hoursassigned === "" &&
                rowToRemove.notes === ""
            ) {
                return []; // remove the empty object
            }

            // Otherwise, remove normally
            return prev.filter((_, i) => i !== index);
        });
    };

    const handleTripInputChange = (index, field, value) => {
        if (isViewOnly) return;
        const nextValue =
            field === "value" ? validateAmountValue(value) : value;
        setProjectDescriptionsAssiged((prev) => {
            const newRows = [...prev]; // shallow copy of array
            if (isSyntheticTrainingExpenseRow(newRows[index])) return newRows;
            const updatedRow = { ...newRows[index], [field]: nextValue }; // clone object and update field
            newRows[index] = updatedRow; // replace with updated row
            return newRows;
        });
    };

    const handleAddRow = () => {
        if (isViewOnly) return;
        if (projectDescriptionsAssiged?.length === 0) {
            // If state is empty, add default row
            const newRow = { description: "", value: "", notes: "" };
            setProjectDescriptionsAssiged([newRow]);
        } else if (projectDescriptionsAssiged.length < 15) {
            // Otherwise, add a new row normally
            setProjectDescriptionsAssiged([
                ...projectDescriptionsAssiged,
                { description: "", value: "", notes: "" },
            ]);
        } else {
            // Optional: show a snackbar or message
            // enqueueSnackbar("You can only add up to 15 rows.", { variant: "error" });
        }
    };

    const handleRemoveRow = (index) => {
        if (isViewOnly) return;
        if (isSyntheticTrainingExpenseRow(projectDescriptionsAssiged?.[index])) return;
        const updatedRows = projectDescriptionsAssiged?.filter(
            (_, i) => i !== index
        );
        setProjectDescriptionsAssiged(updatedRows);
    };

    const validateDescriptionOrNotes = (value) => {
        return value.replace(/[^a-zA-Z0-9 .,?'-]/g, "");
    };

    const handleWorkEntriesSubmit = async () => {
        if (isViewOnly) return;
        const cleanedEntries = projectTasksEntriesAssiged
            ?.filter(entry => {
                return entry.task || entry.hoursassigned || entry.notes;
            })
            .map(entry => ({
                _id: entry._id || null,
                task: entry.task,
                hoursassigned: entry.hoursassigned,
                hoursspent: entry.hoursspent,
                startdate: entry.startdate,
                enddate: entry.enddate,
                expenses: entry.expenses,
                notes: entry.notes,
                oldtaskid: entry.oldtaskid || null,
            }));


        const Payload = {
            projectid: selectedProjectId,
            tasktype: "other",
            taskownerid: emp._id,
            newEntries: cleanedEntries,
        };
        const projectId = selectedProjectId;
        setIsLoading(true);
        try {
            await dispatch(replaceWorkEntriesProjectTrack(Payload));
            await dispatch(setProjectReadTrue(projectId));

            enqueueSnackbar("WorkEntries Added", {
                variant: "success",
            });
            setIsLoading(false);
            dispatch(fetchAllProjects());
            dispatch(fetchWorkEntriesProjectTracking());
        } catch {
            enqueueSnackbar("Failed to save workentries", {
                variant: "error",
            });
            setIsLoading(false);
        } finally {
            setIsLoading(false);
            refreshAssign()
        }
    };

    const handleDescriptionEntriesSubmit = async () => {
        if (isViewOnly) return;
        const cleanedDescriptionEntries = projectDescriptionsAssiged
            ?.filter(entry => {
                return !isSyntheticTrainingExpenseRow(entry) && (entry.description || entry.value || entry.notes || entry.oldtaskid);
            })
            .map(entry => ({
                _id: entry?._id || null,
                description: entry.description,
                value: entry.value,
                notes: entry.notes,
                oldtaskid: entry.oldtaskid || null,
                tripduration: entry.tripduration || tripDuration || 0,
            }));
        const Payload = {
            projectid: selectedProjectId,
            tasktype: "other",
            taskownerid: emp._id,
            entries: cleanedDescriptionEntries,
        };
        const projectId = selectedProjectId;
        setIsLoading(true);
        try {
            await dispatch(saveUpdateDescriptionTask(Payload));
            await dispatch(setProjectReadTrue(projectId));
            enqueueSnackbar("Description Entries Added", {
                variant: "success",
            });
            setIsLoading(false);
            dispatch(fetchAllProjects());
            dispatch(fetchDescriptionTasksProjectTracking());
        } catch {
            enqueueSnackbar("Failed to save Description", {
                variant: "error",
            });
            setIsLoading(false);
        } finally {
            setIsLoading(false);
            refreshAssign()
        }
    };

    const handleSelfWorkEntriesSubmit = async (index) => {
        if (isViewOnly) return;
        const cleanedEntries = projectTasksEntriesAssiged
            ?.filter(entry => {
                return entry.task || entry.hoursassigned || entry.notes;
            })
            .map(entry => ({
                _id: entry._id || null,
                task: entry.task,
                hoursassigned: entry.hoursassigned,
                hoursspent: entry.hoursspent,
                startdate: entry.startdate,
                enddate: entry.enddate,
                expenses: entry.expenses,
                notes: entry.notes,
                oldtaskid: entry.oldtaskid || null,
            }));


        const Payload = {
            projectid: row._id, // optional if API needs it
            tasktype: "self",
            newEntries: cleanedEntries,
        };
        const projectId = row?.projectid;

        setIsLoading(true);
        try {
            await dispatch(replaceWorkEntriesProjectTrack(Payload));
            await dispatch(setProjectReadTrue(projectId));

            enqueueSnackbar("WorkEntries Saved", {
                variant: "success",
            });
            dispatch(fetchAllProjects());
            dispatch(fetchWorkEntriesProjectTracking());
        } catch {
            enqueueSnackbar("Failed to save workentries", {
                variant: "error",
            });
        } finally {
            setIsLoading(false);
            refreshAssign()
        }
    };

    const handleSelfDescriptionEntriesSubmit = async () => {
        if (isViewOnly) return;
        const cleanedDescriptionEntries = projectDescriptionsAssiged
            ?.filter(entry => {
                return !isSyntheticTrainingExpenseRow(entry) && (entry.description || entry.value || entry.notes || entry.oldtaskid);
            })
            .map(entry => ({
                _id: entry?._id || null,
                description: entry.description,
                value: entry.value,
                notes: entry.notes,
                oldtaskid: entry.oldtaskid || null,
                tripduration: entry.tripduration,
            }));

        const Payload = {
            projectid: selectedProjectId,
            tasktype: "self",
            entries: cleanedDescriptionEntries,
        };
        const projectId = selectedProjectId;

        setIsLoading(true);
        try {
            await dispatch(saveUpdateDescriptionTask(Payload));
            await dispatch(setProjectReadTrue(projectId));

            enqueueSnackbar("Description Entries Saved", {
                variant: "success",
            });
            setIsLoading(false);
            dispatch(fetchAllProjects());
            dispatch(fetchDescriptionTasksProjectTracking());
        } catch {
            enqueueSnackbar("Failed to save Description", {
                variant: "error",
            });
            setIsLoading(false);
        } finally {
            setIsLoading(false);
            refreshAssign()
        }
    };

    const handleSelfHardwarePartSubmit = async (emp) => {
        if (isViewOnly) return;
        const hardwareItems = hardwarePartsOp;
        const projectId = emp?.projectid;
        const cleanedHardwareParts = hardwareItems.map((entry) => ({
            _id: entry?._id || null,
            assemblepartdescription: entry.assemblepartdescription,
            partno: entry.partno,
            permonth: entry.permonth,
            quantity: entry.quantity,
            unitprice: entry.unitprice,
            totalprice: entry.totalprice,
            oldtaskid: entry.oldtaskid || null,
        }));

        let payload; // <-- define it here

        if (emp?.customRole[0] === "project manager") {
            payload = {
                projectid: projectId,
                tasktype: "self",
                tasks: cleanedHardwareParts,
            };
        } else if (emp?.customRole[0] === "operations") {
            payload = {
                projectid: projectId,
                tasktype: "other",
                taskownerid: emp?._id,
                tasks: cleanedHardwareParts,
            };
        } else {
            return;
        }

        setIsLoading(true);
        try {
            await dispatch(replaceHardwareProjectTrack(payload));
            await dispatch(setProjectReadTrue(projectId));
            enqueueSnackbar("Hardware Parts Saved", {
                variant: "success",
            });
            dispatch(fetchHardwareProjectTracking());
            dispatch(fetchAllProjects());
        } catch {
            enqueueSnackbar("Failed to save Hardware", {
                variant: "error",
            });
        } finally {
            setIsLoading(false);
            refreshAssign()
        }
    };


    const handleSelfHardwareDescriptionEntriesSubmit = async (emp) => {
        if (isViewOnly) return;
        const descriptionList = projectDescriptionsAssiged;
        // const descriptionList = emp?.DescriptionList;
        const projectId = emp?.projectid;
        const cleanedDescriptionEntries = descriptionList.map(
            (entry) => isSyntheticTrainingExpenseRow(entry) ? null : entry
        ).filter(Boolean).map(
            (entry) => ({
                _id: entry?._id || null,
                description: entry.description,
                value: entry.value,
                notes: entry.notes,
                oldtaskid: entry.oldtaskid || null,
                // tripduration: row?.TypeService?.toLowerCase()?.includes("installation")
                //   ? (Number(tripDurationInput) ?? entry.tripduration ?? null)
                //   : entry.tripduration ?? null,

            }));
        let payload; // <-- define it here
        if (emp?.customRole[0] === "project manager") {
            payload = {
                projectid: projectId,
                tasktype: "self",
                entries: cleanedDescriptionEntries,
            };
        } else if (emp?.customRole[0] === "operations") {
            payload = {
                projectid: projectId,
                tasktype: "other",
                taskownerid: emp?._id,
                entries: cleanedDescriptionEntries,
            };
        } else {
            return;
        }
        setIsLoading(true);
        try {
            await dispatch(saveUpdateDescriptionTask(payload));

            enqueueSnackbar("Description Entries Saved", {
                variant: "success",
            });
            setIsLoading(false);
            dispatch(fetchAllProjects());
            dispatch(fetchDescriptionTasksProjectTracking());
        } catch {
            enqueueSnackbar("Failed to save Description", {
                variant: "error",
            });
            setIsLoading(false);
        } finally {
            setIsLoading(false);
        }
    };


    const [fetchedHardwareData, setfetchedHardwareData] = useState([]);


    useEffect(() => {
        const getGroupId = (value) => {
            if (!value) return "";
            if (typeof value === "object") {
                return String(
                    value?._id ||
                    value?.id ||
                    value?.value ||
                    value?.groupid?._id ||
                    value?.groupid?.id ||
                    value?.groupid ||
                    value?.groupId?._id ||
                    value?.groupId?.id ||
                    value?.groupId ||
                    ""
                ).trim();
            }
            return String(value).trim();
        };

        const targetGroupId =
            getGroupId(row?.groupid) ||
            getGroupId(row?.groupId) ||
            getGroupId(row?.group) ||
            getGroupId(row?.lead?.groupid) ||
            getGroupId(row?.lead?.groupId) ||
            getGroupId(selectedGroupName) ||
            getGroupId(row?.AssignedGroup);

        const matchedInventory =
            targetGroupId
                ? (inventory || []).filter((hardware) => {
                    const inventoryGroupId =
                        getGroupId(hardware?.groupid) ||
                        getGroupId(hardware?.groupId) ||
                        getGroupId(hardware?.group);
                    return inventoryGroupId && inventoryGroupId === targetGroupId;
                })
                : [];

        const newhardwareRows = matchedInventory.map((hardware) => ({
            _id: hardware._id,
            assemblepartdescription: hardware.assembly || "",
            partnumber: hardware.partnumber || "",
            unitprice: hardware.unitprice || "",
        }));

        setfetchedHardwareData(newhardwareRows);
    }, [inventory, row, selectedGroupName]);

    const handleAddHardware = () => {
        if (isViewOnly) return;
        if (hardwarePartsOp.length >= 15) return;

        setHardwarePartsOp([
            ...hardwarePartsOp,
            {
                assemblepartdescription: "",
                partno: "",
                quantity: "",
                unitprice: "",
                totalprice: "",
            },
        ]);
    };

    const handleRemoveHardware = () => {
        if (isViewOnly) return;
        if (hardwarePartsOp.length > 1) {
            const newHardware = [...hardwarePartsOp];
            newHardware.pop();
            setHardwarePartsOp(newHardware);
        }
    };

    const handlehardwareInputChange = (index, key, value) => {
        if (isViewOnly) return;
        const updated = [...hardwarePartsOp];

        if (key === "assemblepartdescription") {
            const selectedPart = fetchedHardwareData?.find(
                (item) => item.assemblepartdescription === value
            );

            if (selectedPart) {
                updated[index] = {
                    ...updated[index],
                    assemblepartdescription: selectedPart.assemblepartdescription,
                    partno: selectedPart.partnumber,
                    unitprice: selectedPart.unitprice.toString(),
                    totalprice:
                        updated[index].quantity && updated[index].quantity !== ""
                            ? (selectedPart.unitprice * Number(updated[index].quantity)).toFixed(2)
                            : "",
                };
            } else {
                updated[index] = {
                    ...updated[index],
                    assemblepartdescription: value,
                    partno: "",
                    unitprice: "",
                    totalprice: "",
                };
            }
        } else if (key === "quantity") {
            const quantity = Number(value);
            const unitprice = Number(updated[index].unitprice || 0);

            updated[index] = {
                ...updated[index],
                quantity: value,
                totalprice:
                    !isNaN(quantity) && quantity !== 0
                        ? (unitprice * quantity).toFixed(2)
                        : "0.00",
            };
        } else {
            updated[index][key] = value;
        }
        setHardwarePartsOp(updated);

    };

    const handleClick = () => {
        if (isViewOnly) return;
        if (hardwarePartsOp.length > 0) {
            const lastItem = hardwarePartsOp[hardwarePartsOp.length - 1];
            dispatch(deleteHardwareDescription(lastItem?._id))
        }
    };


    return (
        <>
            <div className="w-full h-full ">
                {clickedPersonId === emp?._id ? (
                    <>
                        {showListState === "tasktable" && (
                            // {showAction.empId === emp?._id && showAction.type === "tasktable" && (
                            row?.TypeService?.toLowerCase().includes("hardware") ? (
                                <>
                                    {/* <HardwareEditAddOmAssigned
                                emp={emp}
                                setHardwarePartsOp={setHardwarePartsOp}
                                hardwarePartsOp={hardwarePartsOp}
                            /> */}

                                    <div className="flex w-full overflow-auto">
                                        <div className="w-full max-h-[14rem]">
                                            <div className="sticky top-0 flex flex-col w-full z-20">
                                                <div className="w-full">
                                                    <div className="head flex text-center bg-[#1973eb] text-white text-[11px]">
                                                        <div className=" border p-1 w-14  break-all whitespace-normal">Sr.No</div>
                                                        <div className=" border w-44 pt-1  break-all whitespace-normal">
                                                            Part Name
                                                        </div>
                                                        <div className=" border w-20  break-all whitespace-normal  p-1">Part No</div>
                                                        <div className=" border w-24  break-all whitespace-normal p-1">Quantity</div>
                                                        <div className=" border w-24  break-all whitespace-normal p-1">Unit Price ({currency})</div>
                                                        <div className=" border w-36  break-all whitespace-normal p-1">Total Price ({currency})</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="w-full">
                                                {hardwarePartsOp.map((row, index) => (
                                                    <React.Fragment key={index}>
                                                        <div className="flex items-center text-center w-full text-[11px]">
                                                            <div className="w-full">
                                                                <div className="flex">
                                                                    <div className="border w-14 p-1">{index + 1}</div>
                                                                    <div className=" border w-44 break-all whitespace-normal">
                                                                        <select
                                                                            name="assemblepartdescription"
                                                                            value={row.assemblepartdescription || ""}
                                                                            onChange={(e) =>
                                                                                handlehardwareInputChange(
                                                                                    index,
                                                                                    "assemblepartdescription",
                                                                                    e.target.value
                                                                                )
                                                                            }
                                                                            disabled={isViewOnly}
                                                                            className={`outline-none border-none text-center w-full h-full ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-gray-100"}`}
                                                                        >
                                                                            <option value="" disabled hidden>
                                                                                {row.assemblepartdescription ? "" : "Select"}
                                                                            </option>
                                                                            {fetchedHardwareData?.map((option) => {
                                                                                const isAlreadySelected = hardwarePartsOp.some(
                                                                                    (row, i) =>
                                                                                        row.assemblepartdescription ===
                                                                                        option.assemblepartdescription && i !== index
                                                                                );
                                                                                if (isAlreadySelected) return null;
                                                                                return (
                                                                                    <option
                                                                                        key={option._id}
                                                                                        value={option.assemblepartdescription}
                                                                                    >
                                                                                        {option.assemblepartdescription}
                                                                                    </option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                    </div>

                                                                    <div className=" border w-20 p-1  break-all whitespace-normal">
                                                                        {row.partno || " "}
                                                                    </div>

                                                                    <div className=" border w-24 p-1 break-all whitespace-normal">
                                                                        <input
                                                                            type="text"
                                                                            placeholder="Enter quantity"
                                                                            value={row.quantity || ""}
                                                                            onChange={(e) => {
                                                                                let value = e.target.value;
                                                                                if (/^\d*\.?\d{0,3}$/.test(value) || value === "") {
                                                                                    handlehardwareInputChange(index, "quantity", value);
                                                                                }
                                                                            }}
                                                                            onKeyDown={(e) => {
                                                                                if (
                                                                                    !(
                                                                                        (e.key >= "0" && e.key <= "9") ||
                                                                                        e.key === "." ||
                                                                                        e.key === "Backspace" ||
                                                                                        e.key === "Delete" ||
                                                                                        e.key === "ArrowLeft" ||
                                                                                        e.key === "ArrowRight" ||
                                                                                        e.key === "Tab"
                                                                                    )
                                                                                ) {
                                                                                    e.preventDefault();
                                                                                }
                                                                            }}
                                                                            disabled={isViewOnly}
                                                                            className={`outline-none border-none break-all whitespace-normal text-center w-full h-full ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                                                        />

                                                                    </div>

                                                                    <div className=" border p-1 w-24 break-all whitespace-normal">
                                                                        {USAComma(row.unitprice) || " "}
                                                                    </div>

                                                                    <div className=" border p-1 w-36 break-all whitespace-normal">
                                                                        {USAComma(row.totalprice) || " "}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                ))}

                                                {!((emp.fullName === "Self" || emp.customRole[0] === "project manager" || emp.customRole[0] === "operations") &&
                                                    emp?.Assignedperson?.projecttracktaskStatus === "submit"
                                                ) && (
                                                        <>
                                                            {emp.Assignedperson?.operationaction !== "reject" && (
                                                                <div className="flex justify-between px-2 pt-1">
                                                                    <button
                                                                        className={`shadow-xl rounded-md p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                                                        onClick={handleAddHardware}
                                                                        disabled={isViewOnly || hardwarePartsOp.length >= 15}
                                                                    >
                                                                        <AddIcon />
                                                                    </button>
                                                                    <button
                                                                        className={`shadow-xl rounded-md p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                                                        onClick={() => {
                                                                            handleRemoveHardware();
                                                                            handleClick()
                                                                        }}
                                                                        disabled={isViewOnly || hardwarePartsOp.length <= 1}
                                                                    >
                                                                        <RemoveIcon />
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation(); // prevent row onClick from firing
                                        }}
                                        className="flex w-full overflow-auto"
                                    >
                                        <div className="w-full max-h-[14rem]">
                                            <div className="sticky top-0 flex text-center bg-[#1973eb] text-white text-[11px] z-20">
                                                <div className="w-[45%] border p-1">Task</div>
                                                <div className="w-[20%] border p-1">Hrs</div>
                                                <div className="w-[35%] border p-1">Notes</div>
                                            </div>

                                            {/* Second header row (Total) */}
                                            <div className="sticky top-[24px] flex text-center bg-white text-black text-[11px] z-10">
                                                <div className="w-[45%] border p-1">Total</div>
                                                <div className="w-[20%] border p-1">
                                                    {roundHours(projectTasksEntriesAssiged?.reduce((sum, item) => {
                                                        return sum + (parseFloat(item.hoursassigned) || 0);
                                                    }, 0) || 0)}
                                                </div>
                                                <div className="w-[35%] border p-1"></div>
                                            </div>

                                            <div className="w-full">
                                                {projectTasksEntriesAssiged.map((row, index) => {
                                                    const matchedOldWorkEntry = matchedOldRowEntries.find(
                                                        (old) => old._id === row.oldtaskid
                                                    );
                                                    return (
                                                        <React.Fragment key={index}>
                                                            <div className="flex items-center text-center w-full text-[11px]">
                                                                <div className="head flex w-full">
                                                                    {/* Task Input */}
                                                                    <div
                                                                        className="w-[45%] border border-white"
                                                                        title={
                                                                            matchedOldWorkEntry
                                                                                ? `Previous Name: ${matchedOldWorkEntry.task}`
                                                                                : ""
                                                                        }
                                                                    >
                                                                        <input
                                                                            type="text"
                                                                            name="task"
                                                                            value={row.task || ""}
                                                                            onChange={(e) => {
                                                                                const validValue = e.target.value.replace(
                                                                                    /[^a-zA-Z0-9 ]/g,
                                                                                    ""
                                                                                );
                                                                                handleInputChange(
                                                                                    index,
                                                                                    "task",
                                                                                    validValue
                                                                                );
                                                                            }}
                                                                            disabled={isViewOnly}
                                                                            className={`outline-none border-none text-center w-full h-full p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : row.lastEditedFields?.includes("task")
                                                                                ? "bg-gray-400 text-white border "
                                                                                : "border border-white bg-gray-200"
                                                                                }`}
                                                                        />
                                                                    </div>

                                                                    {/* Hours Input */}
                                                                    <div
                                                                        className="w-[20%] border border-white"
                                                                        title={
                                                                            matchedOldWorkEntry
                                                                                ? `Previous Hrs: ${matchedOldWorkEntry.hoursassigned}`
                                                                                : ""
                                                                        }
                                                                    >
                                                                        <input
                                                                            type="text"
                                                                            name="hoursassigned"
                                                                            value={row.hoursassigned || ""}
                                                                            onKeyDown={(e) => {
                                                                                if (["e", "E", "+", "-"].includes(e.key)) {
                                                                                    e.preventDefault();
                                                                                }
                                                                            }}
                                                                            onChange={(e) => {
                                                                                const value = sanitizeDecimalInput(e.target.value);
                                                                                handleInputChange(
                                                                                    index,
                                                                                    "hoursassigned",
                                                                                    value
                                                                                );
                                                                            }}
                                                                            disabled={isViewOnly}
                                                                            className={`outline-none border-none text-center w-full h-full p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : row.lastEditedFields?.includes(
                                                                                "hoursassigned"
                                                                            )
                                                                                ? "bg-gray-400 text-white border "
                                                                                : "border border-white bg-gray-200"
                                                                                }`}
                                                                        />
                                                                    </div>

                                                                    {/* Notes Input */}
                                                                    <div
                                                                        className="w-[35%] border border-white"
                                                                        title={
                                                                            matchedOldWorkEntry
                                                                                ? `Previous Notes: ${matchedOldWorkEntry.notes}`
                                                                                : ""
                                                                        }
                                                                    >
                                                                        <input
                                                                            type="text"
                                                                            name="notes"
                                                                            value={row.notes || ""}
                                                                            onChange={(e) => {
                                                                                const validValue = e.target.value.replace(
                                                                                    /[^a-zA-Z0-9]/g,
                                                                                    ""
                                                                                );
                                                                                handleInputChange(
                                                                                    index,
                                                                                    "notes",
                                                                                    validValue
                                                                                );
                                                                            }}
                                                                            disabled={isViewOnly}
                                                                            className={`outline-none border-none text-center w-full h-full p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : row.lastEditedFields?.includes("notes")
                                                                                ? "bg-gray-400 text-white border "
                                                                                : "border border-white bg-gray-200"
                                                                                }`}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {!(
                                                                (emp.fullName === "Self" || emp.customRole[0] === "project manager" || emp.customRole[0] === "operations") &&
                                                                emp?.Assignedperson?.projecttracktaskStatus === "submit"
                                                            ) && (<>
                                                                {emp.Assignedperson?.operationaction !== "reject" && (
                                                                    <>
                                                                        {(
                                                                            emp.Assignedperson?.projecttracktaskStatus === "pending"
                                                                            || (
                                                                                !(emp.Assignedperson?.manageraction === "complete" || emp.Assignedperson?.operationaction === "complete")
                                                                                && emp.Assignedperson?.projecttracktaskStatus === "submit"
                                                                            )
                                                                        ) && (
                                                                                <>
                                                                                    {index === projectTasksEntriesAssiged.length - 1 && (
                                                                                        <div className="flex justify-between px-2 pt-1 pb-2">
                                                                                            <button
                                                                                                className={`shadow-xl rounded-md p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-gray-100 hover:bg-gray-200"}`}
                                                                                                onClick={handleAddTaskRow}
                                                                                                title="Add row"
                                                                                                disabled={isViewOnly}
                                                                                            >
                                                                                                <AddIcon fontSize="small" />
                                                                                            </button>
                                                                                            <button
                                                                                                className={`shadow-xl rounded-md p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-gray-100 hover:bg-gray-200"}`}
                                                                                                onClick={() => {
                                                                                                    handleRemoveTaskRow(index);
                                                                                                    dispatch(deleteTask([row?._id]))
                                                                                                }}
                                                                                                title="Remove row"
                                                                                                disabled={isViewOnly}
                                                                                            >
                                                                                                <RemoveIcon fontSize="small" />
                                                                                            </button>
                                                                                        </div>
                                                                                    )}

                                                                                </>
                                                                            )}
                                                                    </>
                                                                )}
                                                            </>
                                                                )}

                                                        </React.Fragment>
                                                    );
                                                })}

                                                {projectTasksEntriesAssiged.length === 0 && (
                                                    <div className="flex justify-start px-2 pt-1 ">
                                                        <button
                                                            className={`shadow-xl rounded-md p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                                            onClick={handleAddTaskRow}
                                                            disabled={isViewOnly}
                                                        >
                                                            <AddIcon fontSize="small" />
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ))}

                        {showListState === "otherexpenses" && (
                            // { showAction.empId === emp?._id && showAction.type === "otherexpenses" && (
                            <div className="w-full overflow-auto justify-center pb-2">
                                <div className="max-h-[14rem] ">
                                    <div className="sticky top-0 flex text-center bg-[#1973eb] text-white text-[11px] z-20">
                                        <div className="w-[45%] border p-1">Descriptions</div>
                                        <div className="w-[20%] border p-1">Amount ({currency})</div>
                                        <div className="w-[35%] border p-1">Notes</div>
                                    </div>

                                    {/* Second header row (Total) */}
                                    <div className="sticky top-[24px] flex text-center bg-white text-black text-[11px] z-10">
                                        <div className="w-[45%] border p-1">Total</div>
                                        <div className="w-[20%] border p-1">
                                            {currency}{formatAmountComma(projectDescriptionsAssiged?.reduce((sum, item) => {
                                                return sum + parseAmountNumber(item.value);
                                            }, 0))}
                                        </div>
                                        <div className="w-[35%] border p-1"></div>
                                    </div>
                                    {row?.TypeService?.toLowerCase().includes("installation") && (
                                        <div className="sticky top-[24px] flex text-center bg-white text-black text-[11px] z-10">
                                            <div className="w-[45%] border p-1 flex justify-center items-center">Trip Duration</div>
                                            <div className="w-[20%] border p-1">
                                                <input
                                                    value={tripDuration}
                                                    type="text"
                                                    name="tripduration"
                                                    placeholder="trip duration"
                                                    onChange={handleTripDuration}
                                                    disabled={isViewOnly}
                                                    className={`outline-none border-none text-center w-full h-full p-0.5 border border-white rounded-md ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "text-black"}`}
                                                />
                                            </div>
                                            <div className="w-[35%] border p-1"></div>
                                        </div>
                                    )}

                                    <div className="w-full">
                                        {projectDescriptionsAssiged?.map((row, index) => {
                                            const rowIsSyntheticTrainingExpense = isSyntheticTrainingExpenseRow(row);
                                            const matchedOldDescription = matchedOldRowDesctiption.find(
                                                (old) => old._id === row.oldtaskid
                                            );
                                            return (
                                                <React.Fragment key={index}>
                                                    <div className="flex items-center text-center w-full text-[11px]">
                                                        <div className="w-full">
                                                            <div className="head flex">
                                                                <div
                                                                    className="w-[45%] border border-white"
                                                                    title={
                                                                        matchedOldDescription
                                                                            ? `Previous Name: ${matchedOldDescription.description}`
                                                                            : ""
                                                                    }
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        name="description"
                                                                        value={row.description}
                                                                        onChange={(e) =>
                                                                            handleTripInputChange(
                                                                                index,
                                                                                "description",
                                                                                validateDescriptionOrNotes(e.target.value)
                                                                            )
                                                                        }
                                                                        disabled={isViewOnly || rowIsSyntheticTrainingExpense}
                                                                        className={`outline-none border-none text-center w-full h-full p-1 ${isViewOnly || rowIsSyntheticTrainingExpense ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : row.lastEditedFields?.includes(
                                                                            "description"
                                                                        )
                                                                            ? "bg-gray-400 text-white border "
                                                                            : "border border-white bg-gray-200"
                                                                            }`}
                                                                    />
                                                                </div>

                                                                <div
                                                                    className="w-[20%] border border-white"
                                                                    title={
                                                                        matchedOldDescription
                                                                            ? `Previous Value: ${matchedOldDescription.value}`
                                                                            : ""
                                                                    }
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        name="value"
                                                                        value={formatAmountForInput(row.value)}
                                                                        onChange={(e) =>
                                                                            handleTripInputChange(
                                                                                index,
                                                                                "value",
                                                                                validateAmountValue(e.target.value)
                                                                            )
                                                                        }
                                                                        onKeyDown={(e) => {
                                                                            if (["e", "E", "+", "-"].includes(e.key)) {
                                                                                e.preventDefault();
                                                                            }
                                                                        }}
                                                                        disabled={isViewOnly || rowIsSyntheticTrainingExpense}
                                                                        className={`outline-none border-none text-center w-full h-full p-1 ${isViewOnly || rowIsSyntheticTrainingExpense ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : row.lastEditedFields?.includes("value")
                                                                            ? "bg-gray-400 text-white border "
                                                                            : "border border-white bg-gray-200"
                                                                            }`}
                                                                    />
                                                                </div>

                                                                <div
                                                                    className="w-[35%] border border-white"
                                                                    title={
                                                                        matchedOldDescription
                                                                            ? `Previous Notes: ${matchedOldDescription.notes}`
                                                                            : ""
                                                                    }
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        name="notes"
                                                                        value={row.notes}
                                                                        onChange={(e) =>
                                                                            handleTripInputChange(
                                                                                index,
                                                                                "notes",
                                                                                validateDescriptionOrNotes(e.target.value)
                                                                            )
                                                                        }
                                                                        disabled={isViewOnly || rowIsSyntheticTrainingExpense}
                                                                        className={`outline-none border-none text-center w-full h-full p-1 ${isViewOnly || rowIsSyntheticTrainingExpense ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : row.lastEditedFields?.includes("notes")
                                                                            ? "bg-gray-400 text-white border "
                                                                            : "border border-white bg-gray-200"
                                                                            }`}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {!(
                                                        (emp.fullName === "Self" || emp.customRole[0] === "project manager" || emp.customRole[0] === "operations") &&
                                                        emp?.Assignedperson?.projecttracktaskStatus === "submit"
                                                    ) && (<>

                                                        {emp.Assignedperson?.operationaction !== "reject" && (
                                                            <>
                                                                {(
                                                                    emp.Assignedperson?.projecttracktaskStatus === "pending"
                                                                    || (
                                                                        !(emp.Assignedperson?.manageraction === "complete" || emp.Assignedperson?.operationaction === "complete")
                                                                        && emp.Assignedperson?.projecttracktaskStatus === "submit"
                                                                    )
                                                                ) && (
                                                                        <>
                                                                            {index === projectDescriptionsAssiged?.length - 1 && (
                                                                                <div className="flex justify-between px-2 pt-1">
                                                                                    <button
                                                                                        className={`shadow-xl rounded-md p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                                                                        onClick={handleAddRow}
                                                                                        disabled={isViewOnly || projectDescriptionsAssiged?.length >= 15}
                                                                                    >
                                                                                        <AddIcon />
                                                                                    </button>
                                                                                    <button
                                                                                        className={`shadow-xl rounded-md p-1 ${isViewOnly || rowIsSyntheticTrainingExpense ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                                                                        onClick={() => {
                                                                                            if (rowIsSyntheticTrainingExpense) return;
                                                                                            handleRemoveRow(index);
                                                                                            dispatch(deleteDescriptionTask(row?._id))
                                                                                        }}
                                                                                        disabled={isViewOnly || rowIsSyntheticTrainingExpense}
                                                                                    >
                                                                                        <RemoveIcon />
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        </>)}
                                                            </>)}
                                                    </>
                                                        )}
                                                </React.Fragment>
                                            );
                                        })}


                                        {emp.Assignedperson?.projecttracktaskStatus !== "submit" &&
                                            projectDescriptionsAssiged.length === 0 && (
                                                <div className="flex justify-start px-2 pt-1 ">
                                                    <button
                                                        className={`shadow-xl rounded-md p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                                        onClick={handleAddRow}
                                                        disabled={isViewOnly}
                                                    >
                                                        <AddIcon fontSize="small" />
                                                    </button>
                                                </div>
                                            )}


                                    </div>

                                </div>
                            </div>
                        )}


                        {emp.Assignedperson?.operationaction !== "reject" && (
                            <>
                                {(
                                    emp.Assignedperson?.projecttracktaskStatus === "pending"
                                    || (
                                        !(emp.Assignedperson?.manageraction === "complete" || emp.Assignedperson?.operationaction === "complete")
                                        && emp.Assignedperson?.projecttracktaskStatus === "submit"
                                    )
                                ) && (
                                        <>
                                            {(showListState === "otherexpenses" ||
                                                showListState === "tasktable") && (
                                                    // {(showAction.type === "otherexpenses" ||
                                                    //     showAction.type === "tasktable") && (
                                                    <div className="flex justify-end mb-2 mr-2">
                                                        {projectTasksEntriesAssiged.some(
                                                            (row) =>
                                                                row.taskownerid === loggedEmp._id &&
                                                                loggedEmp.customRoles?.includes("project manager")
                                                        ) ? (
                                                            <>
                                                                {!(
                                                                    (emp.fullName === "Self" || emp.customRole[0] === "project manager" || emp.customRole[0] === "operations") &&
                                                                    emp?.Assignedperson?.projecttracktaskStatus === "submit"
                                                                ) && (
                                                                        <button
                                                                            onClick={() => {
                                                                                handleSelfWorkEntriesSubmit();
                                                                                handleSelfDescriptionEntriesSubmit();
                                                                            }}
                                                                            disabled={isViewOnly}
                                                                            className={`px-2 py-1 rounded-md ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-blue-600 hover:bg-blue-800 text-white"}`}
                                                                        >
                                                                            Submit
                                                                        </button>
                                                                    )}
                                                            </>
                                                        ) : (
                                                            <>
                                                                {(emp?.TypeService?.toLowerCase().includes("hardware")) ? (
                                                                    // {(emp?.TypeService === "Hardware") ? (
                                                                    <>
                                                                        {emp?.customRole[0] === "project manager" ? (
                                                                            <>
                                                                                {!(
                                                                                    (emp.fullName === "Self" || emp.customRole[0] === "project manager" || emp.customRole[0] === "operations") &&
                                                                                    emp?.Assignedperson?.projecttracktaskStatus === "submit"
                                                                                ) && (
                                                                                        <button
                                                                                            onClick={() => {
                                                                                                handleSelfHardwarePartSubmit(emp);
                                                                                                handleSelfHardwareDescriptionEntriesSubmit(emp);
                                                                                            }}
                                                                                            disabled={isViewOnly}
                                                                                            className={`px-2 py-1 rounded-md ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-blue-600 hover:bg-blue-800 text-white"}`}
                                                                                        >
                                                                                            Submit
                                                                                        </button>
                                                                                    )}
                                                                            </>
                                                                        ) : emp?.customRole[0] === "operations" && (
                                                                            <>
                                                                                {!(
                                                                                    (emp.fullName === "Self" || emp.customRole[0] === "project manager" || emp.customRole[0] === "operations") &&
                                                                                    emp?.Assignedperson?.projecttracktaskStatus === "submit"
                                                                                ) && (
                                                                                        <button
                                                                                            onClick={() => {
                                                                                                handleSelfHardwarePartSubmit(emp);
                                                                                                handleSelfHardwareDescriptionEntriesSubmit(emp);
                                                                                            }}
                                                                                            disabled={isViewOnly}
                                                                                            className={`px-2 py-1 rounded-md ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-blue-600 hover:bg-blue-800 text-white"}`}
                                                                                        >
                                                                                            Submit
                                                                                        </button>
                                                                                    )}
                                                                            </>
                                                                        )}


                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {!(
                                                                            (emp.fullName === "Self" || emp.customRole[0] === "project manager" || emp.customRole[0] === "operations") &&
                                                                            emp?.Assignedperson?.projecttracktaskStatus === "submit"
                                                                        ) && (
                                                                                <button
                                                                                    onClick={() => {
                                                                                        handleWorkEntriesSubmit();
                                                                                        handleDescriptionEntriesSubmit();
                                                                                    }}
                                                                                    disabled={isViewOnly || (projectDescriptionsAssiged?.length === 0 && projectTasksEntriesAssiged.length === 0)}
                                                                                    className={`px-2 py-1 rounded-md ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-blue-600 hover:bg-blue-800 text-white"}`}
                                                                                >
                                                                                    Submit
                                                                                </button>
                                                                            )}
                                                                    </>
                                                                )}

                                                            </>
                                                        )}
                                                    </div>
                                                )}
                                        </>)}
                            </>
                        )}
                    </>
                ) : (
                    <div
                        onClick={() =>
                            setClickedPersonId(clickedPersonId === emp?._id ? null : emp?._id)
                        }
                        className="h-full flex-1 flex justify-center items-center align-middle"
                    >
                        Task Details
                    </div>

                )}
            </div>
        </>)
}

export default ShowAssignTableManager